import React from "react";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import { SearchProvider, Results, SearchBox } from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";

import "@elastic/react-search-ui-views/lib/styles/styles.css";

export default function App() {
  return (
    <SearchProvider
      config={{
        onSearch: async state => {
          const response = await fetch(
            'http://api.folklore.dev/q?s=' + state.searchTerm);
          var results = await response.json();
          console.log(results);

          for (var i = 0; i < results.length; ++i) {
            results[i]['id'] = {raw: results[i]['url']};
            results[i]['title'] = {raw: results[i]['title']};
          }

          return {
            results: results,
            totalResults: results.length,
            resultSearchTerm: state.searchTerm
          };
        }
      }}
    >
      <div className="App">
        <Layout
          header={<SearchBox />}
          bodyContent={<Results titleField="title" urlField="id" />}
        />
      </div>
    </SearchProvider>
  );
}
